export default "__VITE_ASSET__CNc8hTaw__"